
 

 

 

 
class MemberUpdateRequest 
{
    
        GroupUID: string;
    
        UserUID: string;
    
}
 
export default MemberUpdateRequest;
 




